module.exports = __webpack_public_path__ + "static/media/main-visual-04.26f2074.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/main-visual-04.mp4
// module id = TUBA
// module chunks = 1